import { AccountType }   from '../api'
import { isInMentoring } from './permissions'

export default (accountType: AccountType) => {
  const isMentoring = isInMentoring(accountType)

  return isMentoring
    ? AccountType.Mentee
    : AccountType.Coachee
}



// WEBPACK FOOTER //
// ./src/project-utils/get-student.ts